import { render, staticRenderFns } from "./TheWrapperWallet.vue?vue&type=template&id=e90c53dc&scoped=true"
import script from "./TheWrapperWallet.vue?vue&type=script&lang=js"
export * from "./TheWrapperWallet.vue?vue&type=script&lang=js"
import style0 from "./TheWrapperWallet.vue?vue&type=style&index=0&id=e90c53dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90c53dc",
  null
  
)

export default component.exports